import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import publicRouteComponent, {
  publicRouteComponentAdmin,
} from "./publicRouteComponents";
import privateRouteAdminComponents from "./privateRouteAdminComponent";
import Navbar from "../components/Navbar/Navbar";
import PrivateLayerAdmin from "../components/PrivateLayerAdmin/PrivateLayerAdmin";
import privateRouteStudentComponents from "./privateRouteStudentComponent";
import PrivateLayerStudent from "../components/PrivateLayerStudent/PrivateLayerStudent";
import PrivateRoutes from "./PrivateRoutes";
import PublicRoutes from "./PublicRoutes";
import PrivateRoutesAdmin from "./PrivateRoutesAdmin";
import { useSelector } from "react-redux";
import PublicRoutesAdmin from "./PublicRoutesAdmin";

export default function RootRoutes() {
  const auth = useSelector((state) => state.auth);
  return (
    <Router>
      <Routes>
        {/* PUBLIC ROUTES  Student*/}
        {publicRouteComponent.map((publicRoute, index) => (
          <Route
            key={`${index}_${publicRoute.path}`}
            path={publicRoute.path}
            element={<PublicRoutes>{publicRoute.component}</PublicRoutes>}
          />
        ))}
        {/* PUBLIC ROUTES  Admin*/}
        {publicRouteComponentAdmin.map((publicRoute, index) => (
          <Route
            key={`${index}_${publicRoute.path}`}
            path={publicRoute.path}
            element={
              <PublicRoutesAdmin>{publicRoute.component}</PublicRoutesAdmin>
            }
          />
        ))}
        {/* PRIVATE ROUTES FOR ADMIN */}
        {privateRouteAdminComponents.map((privateAdminRoute, index) => (
          <Route
            key={`${index}_${privateAdminRoute.path}`}
            path={`/admin${privateAdminRoute.path}`}
            element={
              <PrivateRoutesAdmin>
                <Navbar isAdmin={true} user="admin" />
                <PrivateLayerAdmin>
                  {privateAdminRoute.component}
                </PrivateLayerAdmin>
              </PrivateRoutesAdmin>
            }
          />
        ))}
        {/* PRIVATE ROUTES FOR STUDENT */}
        {privateRouteStudentComponents.map((privateRouteStudent, index) => (
          <Route
            key={`${index}_${privateRouteStudent.path}`}
            path={`${privateRouteStudent.path}`}
            element={
              <PrivateRoutes>
                <Navbar isAdmin={false} user={auth?.user?.name} />
                <PrivateLayerStudent>
                  {privateRouteStudent.component}
                </PrivateLayerStudent>
              </PrivateRoutes>
            }
          />
        ))}
      </Routes>
    </Router>
  );
}
